export const myProductMutation = `mutation mutate ($productId: ID!, $supplierId: ID!, $update: ProfileProductInputType! ){
  editProduct (
    productId: $productId,
    supplierId: $supplierId,
    update:$update,
  ) {
    locationId
    productId
    isMarketingReady
  }
}`;

export const myProductProfileQuery = `query getMyProductProfile ($productId: ID!) {
      productProfile  (id: $productId) {
        id
        name
        productId
        amenities
        bedsAndSofas {
          isApartment
          rooms {
            count
            bedType
            other
          }
        }
        checkIn
        checkOut
        description
        imageUrls
        isMarketingReady
        interconnectingRooms
        locationName
        locationId
        productCode
        notes
        totalMaxPassengers
        totalMinPassengers
        productName
        companyId
        companyName
        profileImageUrl
        coverImageUrl
        tourDuration {
          value
          unit
        }
        tourDurationDoesNotApply
        roomCountInfo {
          value
          unit
        }
        roomSizeInfo {
          value
          unit
        }
        productInfo {
          include
          exclude
          whatToBring
        }
        roomSize
        productType
        type
      }
    }`;




// WEBPACK FOOTER //
// ./src/app/stores/profile/product/product-graphql-query.js